import html from "./ExternalApplication.html"
import "./ExternalApplication.css"
import "../../Shared/UrlWhitelistValidator.js"
import "../ParticipantDeviceInfoService.js"
import getViewViewedLogger from "../../../api/participant/viewAnalytics";

var module = angular.module("ResearchKitApplicationModule");
module.component('externalApplication', {
	template: html,
	bindings: {
		url: '<',
		patientId: '<',
		tabKey: '<',
		whitelistedUrls: '<',
		onNewExternalAppOpen: '&',
		onDismiss: '&',
		onBack: '&',
		colorScheme: '<',
		disableDefaultInteractions: '<',
		disableViewLogging: '<'
	},
	controller: 'externalApplicationController',
	controllerAs: 'vm'
});

module.controller("externalApplicationController", ["$sce", "$window", "$element", "$http", "$scope", "$translate", "delegatedOAuthClient", "ceUrl", "participantDeviceInfoService", "providerAccountService", "urlWhitelistValidator",
	function ($sce, $window, $element, $http, $scope, $translate, delegatedOAuthClient, ceUrl, participantDeviceInfoService, providerAccountService, urlWhitelistValidator) {
		var vm = this;
		var viewViewedLogger = getViewViewedLogger();

		vm.$onChanges = function (changesObj) {
			var hasChanged = false;
			Object.keys(changesObj).forEach(function (k) {
				if (!_.isEqual(changesObj[k].currentValue, changesObj[k].previousValue)) {
					hasChanged = true;
				}
			});
			if (!hasChanged) return;

			if (vm.url && vm.whitelistedUrls && vm.whitelistedUrls.length) {
				if (urlWhitelistValidator.isWhitelisted(vm.url, vm.whitelistedUrls)) {
					var url = new URL(vm.url);
					url.searchParams.set("lang", $translate.use());
					url.searchParams.set("colorScheme", vm.colorScheme.toLowerCase());

					// Replace iframe completely to prevent creating entries in window.history on src changes
					var originalFrame = $element.find("iframe")[0];
					var newFrame = document.createElement("iframe");
					newFrame.onload = function () {
						if (!vm.disableViewLogging) {
							viewViewedLogger({ ViewUrl: vm.url, TabKey: vm.tabKey, ParticipantID: vm.patientId, Platform: "Web" });
						}
						newFrame.contentWindow.postMessage({ type: "applicationDidBecomeVisible" }, url.href);
					};
					newFrame.src = url.href;
					newFrame.className = "external-app-frame";
					var parent = originalFrame.parentNode;
					parent.replaceChild(newFrame, originalFrame);
				}
			}
		};

		vm.$onDestroy = function () {
			$window.removeEventListener("message", externalAppMessageHandler);
		};

		$element.on("$destroy", function () {
			$window.removeEventListener("message", externalAppMessageHandler);

			$scope.$destroy();
		});

		$window.addEventListener("message", externalAppMessageHandler);

		function externalAppMessageHandler(event) {
			var origin = new URL(vm.url).origin;
			if (event.origin !== origin) return;
			if (event.source !== $element.find("iframe")[0].contentWindow) return;

			if (event.data) {
				switch (event.data.name) {
					case "GetDelegatedAccessToken":
						$http({
							method: 'POST',
							url: ceUrl.make('identityserver/connect/token'),
							data: $.param({
								grant_type: "delegated_participant",
								participant_id: vm.patientId,
								client_id: delegatedOAuthClient.ClientID,
								client_secret: delegatedOAuthClient.ClientSecret,
								scope: "api user/*.read"
							}),
							headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
						}).then(function (response) {
							$element.find("iframe")[0].contentWindow.postMessage({ action: "GetDelegatedAccessToken", success: true, data: response.data, messageID: event.data.messageID, baseUrl: $window.location.origin + ceUrl.getRoot() }, vm.url);
						}).catch(function () {
							$element.find("iframe")[0].contentWindow.postMessage({ action: "GetDelegatedAccessToken", success: false, message: "Unable to retrieve access token", messageID: eventData.messageID }, vm.url);
						});
						break;
					case "GetDeviceInfo":
						$scope.$apply(function () {
							let deviceInfo = participantDeviceInfoService.getDeviceInfo();

							$element.find("iframe")[0].contentWindow.postMessage({ action: "GetDeviceInfo", success: true, data: deviceInfo, messageID: event.data.messageID }, vm.url);
						});
						break;
					case "StartParticipantSurvey":
						if (vm.disableDefaultInteractions) break;
						$scope.$apply(function () {
							$scope.$emit("performAction", {
								type: "StartParticipantSurvey",
								parameters: {
									surveyName: event.data.surveyName,
									options: event.data.options
								},
								patientID: vm.patientId
							});
						});
						break;
					case "OpenExternalUrl":
					case "OpenEmbeddedUrl":
						window.open(event.data.url, "_blank");
						break;
					case "OpenApplication":
						$scope.$apply(function () {
							vm.onNewExternalAppOpen({ event: event.data });
						});
						break;
					case "Dismiss":
						$scope.$apply(function () {
							vm.onDismiss({ event: event.data });
						});
						break;
					case "Back":
						$scope.$apply(function () {
							vm.onBack({ event: event.data });
						});
						break;
					case "ShowTab":
						if (vm.disableDefaultInteractions) break;
						$scope.$apply(function () {
							$scope.$emit("performAction", {
								type: "ShowTab",
								parameters: event.data.tabKey,
								patientID: vm.patientId
							});
						});
						break;
					case "ShowParticipantDashboard":
						if (vm.disableDefaultInteractions) break;
						$scope.$apply(function () {
							$scope.$emit("performAction", {
								type: "ShowParticipantDashboard",
								parameters: event.data,
								patientID: vm.patientId
							});
						});
						break;
					case "ShowParticipantWebVisualization":
						if (vm.disableDefaultInteractions) break;
						$scope.$apply(function () {
							$scope.$emit("performAction", {
								type: "ShowParticipantWebVisualization",
								parameters: event.data,
								patientID: vm.patientId
							});
						});
						break;
					case "ShowParticipantWebVisualizationPDF":
						if (vm.disableDefaultInteractions) break;
						$scope.$apply(function () {
							$scope.$emit("performAction", {
								type: "ShowParticipantWebVisualizationPDF",
								parameters: event.data,
								patientID: vm.patientId
							});
						});
						break;
					case "DeleteProviderAccount":
						if (vm.disableDefaultInteractions) break;
						providerAccountService.promptForAccountRemoval(event.data, $element.find("iframe")[0].contentWindow, vm.url);
						break;
					case "ConnectExternalAccount":
						if (vm.disableDefaultInteractions) break;
						$scope.$apply(function () {
							$scope.$emit("performAction", {
								type: "ConnectExternalAccount",
								parameters: event.data
							});
						});
						break;
					case "ShowProject":
						if (vm.disableDefaultInteractions) break;
						$scope.$apply(function () {
							$scope.$emit("performAction", {
								type: "ShowProject",
								parameters: event.data
							});
						});
						break;
					case "JoinProject":
						if (vm.disableDefaultInteractions) break;
						$scope.$apply(function () {
							$scope.$emit("performAction", {
								type: "JoinProject",
								parameters: event.data
							});
						});
						break;
					default:
						break;
				}
			}
		}

		$scope.$on("surveyDidFinish", function (event, parameters) {
			var externalAppWindow = $element.find("iframe")[0].contentWindow;
			externalAppWindow.postMessage(parameters, vm.url);
			externalAppWindow.postMessage({ type: "applicationDidBecomeVisible" }, vm.url);
		});

		$scope.$on("applicationDidBecomeVisible", function (event, parameters) {
			$element.find("iframe")[0].contentWindow.postMessage(parameters, vm.url);
		});

		$scope.$on("connectExternalAccountDidFinish", function (event, parameters) {
			$element.find("iframe")[0].contentWindow.postMessage(parameters, vm.url);
		});
	}
]);